import { StorageData, User } from '../types/auth.types';

const STORAGE_KEY = 'auth_data';

export class StorageService {
  static saveAuthData(data: StorageData): void {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (error) {
      console.error('Error saving auth data to storage:', error);
    }
  }

  static getAuthData(): StorageData | null {
    try {
      const data = localStorage.getItem(STORAGE_KEY);
      return data ? JSON.parse(data) : null;
    } catch (error) {
      console.error('Error reading auth data from storage:', error);
      return null;
    }
  }

  static getAccessToken(): string | null {
    const data = this.getAuthData();
    return data?.accessToken || null;
  }

  static getRefreshToken(): string | null {
    const data = this.getAuthData();
    return data?.refreshToken || null;
  }

  static getExpiresIn(): number | null {
    const data = this.getAuthData();
    return data?.expiresIn || null;
  }

  static getUser(): User | null {
    const data = this.getAuthData();
    return data?.user || null;
  }

  static clearAuthData(): void {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (error) {
      console.error('Error clearing auth data from storage:', error);
    }
  }

  static isTokenExpired(): boolean {
    const expiresIn = this.getExpiresIn();
    if (!expiresIn) return true;
    
    const currentTime = Date.now();
    const expirationTime = expiresIn;
    
    return currentTime >= expirationTime;
  }
} 